import React from 'react';
import { PaletteIcon, BookmarkIcon, ImageIcon } from 'lucide-react';
import { Screen } from '../ui/Screen';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
export const PersonalizationSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-787">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-788">
        Personalisatie als Gamification-versterker
      </h2>
      <div className="flex items-center mb-5" data-id="element-789">
        <PaletteIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-790" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-791">
          Personalisatie geeft gebruikers een gevoel van eigenaarschap en
          controle, wat de gamification-elementen krachtiger maakt.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" data-id="element-792">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-793">
          <h3 className="text-xl font-light text-[#333333] mb-3 flex items-center" data-id="element-794">
            <PaletteIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-795" />
            Ontgrendelbare Thema's
          </h3>
          <p className="text-[#666666] text-xs mb-3 leading-relaxed" data-id="element-796">
            Na consistente check-ins kunnen gebruikers exclusieve visuele
            thema's ontgrendelen die passen bij de luxe uitstraling van Mosy.
          </p>
          <div className="bg-white p-3 rounded-lg" data-id="element-797">
            <div className="flex justify-between items-center mb-2" data-id="element-798">
              <h4 className="text-sm font-light text-[#444444] flex items-center" data-id="element-799">
                <ImageIcon className="w-4 h-4 text-[#d4af37] mr-2" data-id="element-800" />
                Sunset Waves
              </h4>
              <Badge label="Vrijgespeeld na 7 check-ins" variant="filled" data-id="element-801" />
            </div>
            <div className="grid grid-cols-5 gap-2 mb-2" data-id="element-802">
              <div className="h-6 rounded-lg bg-[#e8c285]" data-id="element-803"></div>
              <div className="h-6 rounded-lg bg-[#d4af37]" data-id="element-804"></div>
              <div className="h-6 rounded-lg bg-[#e8d2a0]" data-id="element-805"></div>
              <div className="h-6 rounded-lg bg-[#f7ead7]" data-id="element-806"></div>
              <div className="h-6 rounded-lg bg-[#f9f4eb]" data-id="element-807"></div>
            </div>
            <p className="text-xs text-[#666666] leading-relaxed" data-id="element-808">
              Warme, kalme kleuren geïnspireerd door zonsondergang aan zee,
              perfect voor avondmeditaties.
            </p>
          </div>
        </div>
        <Screen title="Gepersonaliseerde Ervaring" description="Gamification via personalisatie" data-id="element-809">
          <div className="h-full flex flex-col" data-id="element-810">
            <div className="bg-[#e8c285] bg-opacity-20 p-3 rounded-t-lg border-b border-[#e8c285]" data-id="element-811">
              <div className="flex justify-between items-center" data-id="element-812">
                <h4 className="text-sm font-light text-[#d4af37]" data-id="element-813">mosy</h4>
                <Badge label="Sunset Waves" variant="outline" icon={<PaletteIcon className="w-2.5 h-2.5" data-id="element-815" />} data-id="element-814" />
              </div>
            </div>
            <div className="flex-1 p-4 bg-gradient-to-b from-[#f9f4eb] to-white" data-id="element-816">
              <h4 className="text-base font-light text-[#d4af37] mb-3" data-id="element-817">
                Welkom terug, Anna
              </h4>
              <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f7ead7] mb-3" data-id="element-818">
                <div className="flex items-center justify-between mb-2" data-id="element-819">
                  <p className="text-xs text-[#d4af37] font-medium" data-id="element-820">
                    Jouw balansreeks
                  </p>
                  <span className="text-xs text-[#e8c285]" data-id="element-821">7 dagen</span>
                </div>
                <div className="w-full h-1.5 bg-[#f7ead7] rounded-full mb-2" data-id="element-822">
                  <div className="h-full w-4/5 bg-[#d4af37] rounded-full" data-id="element-823"></div>
                </div>
                <p className="text-xs text-[#e8c285]" data-id="element-824">
                  Nog 7 dagen voor Ocean Calm thema
                </p>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm border border-[#f7ead7] mb-3" data-id="element-825">
                <p className="text-xs text-[#d4af37] font-medium mb-2" data-id="element-826">
                  Aanbevolen voor jou
                </p>
                <div className="flex items-center" data-id="element-827">
                  <div className="w-10 h-10 rounded-full bg-[#e8c285] bg-opacity-20 flex items-center justify-center mr-3" data-id="element-828">
                    <BookmarkIcon className="w-4 h-4 text-[#d4af37]" data-id="element-829" />
                  </div>
                  <div data-id="element-830">
                    <p className="text-xs text-[#d4af37]" data-id="element-831">
                      Ademhaling voor focus
                    </p>
                    <p className="text-xs text-[#e8c285] mt-1" data-id="element-832">5 min • Nieuw</p>
                  </div>
                </div>
              </div>
              <Button data-id="element-833">Check in</Button>
            </div>
          </div>
        </Screen>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-834">
        <h3 className="text-lg font-light text-[#333333] mb-3 text-center" data-id="element-835">
          Nieuwe Personalisatie-Mogelijkheden
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-836">
          <div className="bg-white p-3 rounded-lg" data-id="element-837">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-838">
              Persoonlijke Dashboard
            </p>
            <p className="text-xs text-[#666666]" data-id="element-839">
              Gebruikers kunnen hun dashboard aanpassen met widgets die voor hen
              belangrijk zijn
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-840">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-841">
              Aangepaste Notificaties
            </p>
            <p className="text-xs text-[#666666]" data-id="element-842">
              Gebruikers kunnen kiezen welk type notificaties ze ontvangen en
              wanneer
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-843">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-844">
              Voortgangsvisualisatie
            </p>
            <p className="text-xs text-[#666666]" data-id="element-845">
              Keuze uit verschillende manieren om voortgang te visualiseren
              (cirkel, pad, boom)
            </p>
          </div>
        </div>
      </div>
    </div>;
};